import { useAppSelector } from '../../../../app/hooks';
import { DATA_FETCH_STATUS, GRAPH_NAMES } from '../../../../store/dashboard/constants';
import { MSME_DELAYS_TILE_TITLE } from '../../../../store/dashboard/compliancesBefe/constants';
import StatCard from './StatCard';
import type { MsmeDelaysStatCardProps } from './types';

const MSME_DELAYS_STAT_NAME = 'msmeDelays';
const MSME_DELAYS_EMPTY_TILE = { title: MSME_DELAYS_TILE_TITLE };

/** The Compliances MSME Delays headline tile, built from the MSME card's BEFE response in redux. */
function MsmeDelaysStatCard({ isPDFReport, isCompliance }: MsmeDelaysStatCardProps) {
    const chart = useAppSelector((state) => state.dashboard.dashboardReducer.charts?.[GRAPH_NAMES.MSME_PAYMENT_DELAYS]);
    const hasFailed = chart?.fetchError && !chart.isLoading;
    const isLoading =
        !hasFailed &&
        !chart?.headlineCard &&
        (!chart?.isFetched || chart.isLoading || chart.metadata?.status === DATA_FETCH_STATUS.PROCESSING);

    return (
        <StatCard
            data={isLoading ? {} : (!hasFailed && chart?.headlineCard) || MSME_DELAYS_EMPTY_TILE}
            statName={MSME_DELAYS_STAT_NAME}
            isLoading={isLoading}
            isPDFReport={isPDFReport}
            isCompliance={isCompliance}
        />
    );
}

export default MsmeDelaysStatCard;
